import { WipBuyInfo } from "./wip-buy-info.model";

export class KomFeed {
	[x: string]: any;
	public id: number;
	public komfeedid: number;
	public adjustmentFeed: string;
	public entAdjustmentFeed: string;
	public corp: any;
	public house: string;
	public orderFromDate: any;
	public orderToDate: any;
	public sales_rep_id: any;
	public tech: number;
	public sales_addition_code: number;
	public curr_product_class_id: any;
	public prev_product_class_id: any;
	public addition_code_id: any;
	public deletion_code_id: any;
	public curr_mdm_tier_rpt: number;
	public prev_mdm_tier_rpt: number;
	public prem_upgr_downgr_flag: number;
	public net_rev_change: number;
	public recurring_rev: number;
	public video_add_flag: number;
	public ool_add_flag: number;
	public restel_add_flag: number;
	public io_add_flag: number;
	public ov_add_flag: number;
	public comm_year: number;
	public promo_amt: number;
	public internal_net_ool: number;

	public vr_unit_revenue: number;

	public vow_unit: number;
	public vow_unit_revenue: number;
	public svod_revenue_change: number;
	public misc_video_revenue_change: number;
	public total_dvr_revenue_change: number;
	public dvr_revenue_change: number;
	public curr_chrg_buffers: number;
	public curr_nonchrg_buffers: number;
	public prev_chrg_buffers: number;
	public prev_nonchrg_buffers: number;
	public ool_revenue_change: number;
	public iptel_revenue_change: number;
	public analog_revenue_change: number;
	public io_revenue_change: number;
	public curr_addl_did_blocks: number;
	public prev_addl_did_blocks: number;
	public m2m_revenue_change: number;
	public install_revenue: number;
	public mdu_flag: number;
	public auto_ind: number;
	public auto_pay: number;
	public account_id: number;
	public prev_non_ported_lines: number;
	public curr_non_ported_lines: number;
	public prev_tf_lines: number;
	public curr_tf_lines: number;
	public dvr_plus_add_flag: number;
	public dvr_plus_free_flag: number;
	public dvr_plus_remove_flag: number;
	public dvr_plus_unit_revenue: number;
	public dvr_unit_revenue: number;

	public dvr_plus_unit: number;



	public free_dvr_unit: number;
	public pia_revenue: number;
	public sip_add_revenue: number;
	public sip_remove_revenue: number;
	public exclude_from_yield: number;
	public net_ov: number;
	public internal_net_ov: number;
	public zip_blitz: number;
	public dvr_unit: number;
	public dvr_revenue: number;
	public prev_new_video_offer_id: number;
	public curr_new_video_offer_id: number;
	public net_rev_change_a: number;
	public net_rev_change_o: number;
	public net_rev_change_d: number;
	public net_rev_change_ov: number;
	public net_rev_change_restel: number;
	public net_prem_chanels: number;
	public net_svod: number;
	public net_sports: number;
	public net_converters: number;
	public net_restel: number;
	public net_ool: number;
	public pr_status_id: number;
	public last_modified_by: string;
	public employee_pay_id: number;
	public flat_rate_ncr: number;
	public cust: string;
	public wpcnt: string;
	public wstat: string;
	public who: string;
	public cust_type: string;
	public revenue_upgr_downgr_flag: string;
	public io_upgr_downgr_flag: string;
	public winback_flag: string;
	public comm_month: string;
	public wcampg: string;
	public prev_sports_combo_str: string;
	public curr_sports_combo_str: string;
	public prev_svod_combo_str: string;
	public curr_svod_combo_str: string;
	public prev_intl_combo_str: string;
	public curr_intl_combo_str: string;
	public prev_io_combo_str: string;
	public curr_io_combo_str: string;
	public prev_ool_combo_str: string;
	public curr_ool_combo_str: string;
	public prev_ov_combo_str: string;
	public curr_ov_combo_str: string;
	public prev_misc_combo_str: string;
	public curr_misc_combo_str: string;
	public drsn: string;
	public drsn_remove_chgbk: string;
	public m2m_speed: string;
	public add_svod_combo_str: string;
	public del_svod_combo_str: string;
	public customer_type: string;
	public created_by: string;
	public updated_by: string;
	public wordate: Date;
	public wfindate: any;
	public wddate: Date;



	public feed_dt: Date;
	public last_modified_on: Date;
	public ordertime: Date;
	public begin_date: Date;
	public created_dt: Date;
	public updated_dt: Date;

	public sercnt: number;
	public samt: number;
	public f_level: number;
	public serty_id: string;
	public ratecd: string;
	public ratesign: string;

	public wipBuyInfo: WipBuyInfo;
	public wibBuyInfoID: number;
	public svcsType: string;

	public descrip1: string;
	public descrip2: string;

	public status: string;
	public productName: string;
	public majorarea: string;
	public custname: string;

	public wordate_stg: Date;
	public wfindate_stg: Date;
	public wddate_stg: Date;


	public kom_code: number;

	public si_activation_flag: string;
	public si_activation_date: any;

	public rctr01: string;
	public rctr02: string;
	public rctr03: string;
	public rctr04: string;
	public rctr05: string;
	public rctr06: string;
	public rctr07: string;
	public rctr08: string;
	public rctr09: string;
	public rctr10: string;

	public rctr11: string;
	public rctr12: string;
	public rctr13: string;
	public rctr14: string;
	public rctr15: string;
	public rctr16: string;
	public rctr17: string;
	public rctr18: string;
	public rctr19: string;
	public rctr20: string;

	public rc01: string;
	public rc02: string;
	public rc03: string;
	public rc04: string;
	public rc05: string;
	public rc06: string;
	public rc07: string;
	public rc08: string;
	public rc09: string;
	public rc10: string;

	public rc11: string;
	public rc12: string;
	public rc13: string;
	public rc14: string;
	public rc15: string;
	public rc16: string;
	public rc17: string;
	public rc18: string;
	public rc19: string;
	public rc20: string;

	public on_or_off_turf:any;
	public system_id:number;
	public lead_assigned_date:any;
	public field_value:string;
	public field_name:string;

	constructor() {
		this.on_or_off_turf = null;
		this.system_id = null;
		this.lead_assigned_date = null;
		this.field_value = null;
		this.field_name = null;

		this.si_activation_flag = null;
		this.si_activation_date = null;

		this.kom_code = null;
		this.rctr01 = null;
		this.wordate_stg = null;
		this.wfindate_stg = null;
		this.wddate_stg = null;

		this.custname = null;
		this.majorarea = null;
		this.productName = null;
		this.status = null;
		this.descrip1 = null;
		this.descrip2 = null;
		this.id = null;
		this.komfeedid = null;
		this.adjustmentFeed = null;
		this.entAdjustmentFeed = null;
		this.corp = null;
		this.house = null;
		this.orderFromDate = null;
		this.orderToDate = null;
		this.sales_rep_id = null;
		this.tech = null;
		this.sales_addition_code = null;
		this.addition_code_id = null;
		this.deletion_code_id = null;
		this.curr_product_class_id = null;
		this.prev_product_class_id = null;
		this.curr_mdm_tier_rpt = null;
		this.prev_mdm_tier_rpt = null;
		this.prem_upgr_downgr_flag = null;
		this.net_rev_change = null;
		this.recurring_rev = null;
		this.video_add_flag = null;
		this.ool_add_flag = null;
		this.restel_add_flag = null;
		this.io_add_flag = null;
		this.ov_add_flag = null;
		this.comm_year = null;
		this.promo_amt = null;
		this.internal_net_ool = null;
		this.vr_unit_revenue = null;
		this.pia_revenue = null;
		this.sip_add_revenue = null;
		this.sip_remove_revenue = null;
		this.vow_unit = null;
		this.vow_unit_revenue = null;
		this.svod_revenue_change = null;
		this.misc_video_revenue_change = null;
		this.total_dvr_revenue_change = null;
		this.dvr_revenue_change = null;
		this.curr_chrg_buffers = null;
		this.curr_nonchrg_buffers = null;
		this.prev_chrg_buffers = null;
		this.prev_nonchrg_buffers = null;
		this.ool_revenue_change = null;
		this.iptel_revenue_change = null;
		this.analog_revenue_change = null;
		this.io_revenue_change = null;
		this.curr_addl_did_blocks = null;
		this.prev_addl_did_blocks = null;
		this.m2m_revenue_change = null;
		this.install_revenue = null;
		this.mdu_flag = null;
		this.auto_ind = null;
		this.auto_pay = null;
		this.account_id = null;
		this.prev_non_ported_lines = null;
		this.curr_non_ported_lines = null;
		this.prev_tf_lines = null;
		this.curr_tf_lines = null;
		this.dvr_plus_add_flag = null;
		this.dvr_plus_free_flag = null;
		this.dvr_plus_remove_flag = null;
		this.dvr_plus_unit_revenue = null;
		this.dvr_unit_revenue = null;
		this.free_dvr_unit = null;
		this.dvr_plus_unit = null;
		this.exclude_from_yield = null;
		this.net_ov = null;
		this.internal_net_ov = null;
		this.zip_blitz = null;
		this.dvr_unit = null;
		this.dvr_revenue = null;
		this.prev_new_video_offer_id = null;
		this.curr_new_video_offer_id = null;
		this.net_rev_change_a = null;
		this.net_rev_change_o = null;
		this.net_rev_change_d = null;
		this.net_rev_change_ov = null;
		this.net_rev_change_restel = null;
		this.net_prem_chanels = null;
		this.net_svod = null;
		this.net_sports = null;
		this.net_converters = null;
		this.net_restel = null;
		this.net_ool = null;
		this.pr_status_id = null;
		this.last_modified_by = null;
		this.employee_pay_id = null;
		this.corp = null;
		this.flat_rate_ncr = null;
		this.cust = null;
		this.wpcnt = null;
		this.wstat = null;
		this.who = null;
		this.sales_rep_id = null;
		this.cust_type = null;
		this.revenue_upgr_downgr_flag = null;
		this.io_upgr_downgr_flag = null;
		this.winback_flag = null;
		this.comm_month = null;
		this.wcampg = null;
		this.prev_sports_combo_str = null;
		this.curr_sports_combo_str = null;
		this.prev_svod_combo_str = null;
		this.curr_svod_combo_str = null;
		this.prev_intl_combo_str = null;
		this.curr_intl_combo_str = null;
		this.prev_io_combo_str = null;
		this.curr_io_combo_str = null;
		this.prev_ool_combo_str = null;
		this.curr_ool_combo_str = null;
		this.prev_ov_combo_str = null;
		this.curr_ov_combo_str = null;
		this.prev_misc_combo_str = null;
		this.curr_misc_combo_str = null;
		this.drsn = null;
		this.drsn_remove_chgbk = null;
		this.m2m_speed = null;
		this.add_svod_combo_str = null;
		this.del_svod_combo_str = null;
		this.customer_type = null;
		this.created_by = null;
		this.updated_by = null;
		this.wordate = null;
		this.wfindate = null;
		this.wddate = null;
		this.feed_dt = null;
		this.last_modified_on = null;
		this.ordertime = null;
		this.begin_date = null;
		this.created_dt = null;
		this.updated_dt = null;
		this.wipBuyInfo = null;
		this.serty_id = null;
		this.sercnt = null;
		this.samt = null;
		this.ratecd = null;
		this.ratesign = null;
		this.wibBuyInfoID = null;
		this.svcsType = null;
	}
}
